import React from 'react';
import { Portfolio } from './pages/Portfolio';
export function App() {
  return <Portfolio data-id="element-0" />;
}